import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledAddCardRow = styled.div<{ $showDivider?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-top: ${props =>
    props.$showDivider ? '1px solid var(--Color-Set-horizontal-vertical-rule, #C4C4C4)' : 'none'};
  padding-top: ${props => (props.$showDivider ? '24px' : '0')};
  width: 100%;

  @media ${baseVariables.mediaQuery.md} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;
